import { useState } from 'react';
import { HelpTip, PanelHowTo } from './_barrel.js';


        // Persistent posters — accounts posting on many separate days over 90d.
        // Surfaces the below-hostile-threshold pattern the Hostile Mention Watch
        // structurally misses (the low-and-slow fixated account).
        function PersistentPostersPanel({ subject, onSelectAccount }) {
            const posters = (subject && subject.persistent_posters) || [];
            const [showAll, setShowAll] = useState(false);
            const [open, setOpen] = useState(false);
            if (posters.length === 0) return null;
            const belowThreshold = posters.filter(p => (p.hostile_count || 0) === 0);
            const shown = showAll ? posters : posters.slice(0, 8);
            const fmtDate = (s) => s ? new Date(s).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : '';
            return (
                <div className="panel p-6 mb-8" style={{ borderLeft: '3px solid var(--gold)' }}>
                    <PanelHowTo id="persistent_posters" />
                    <div className="flex items-center justify-between mb-2 cursor-pointer" onClick={() => setOpen(!open)}>
                        <div className="font-display text-xl gold">Persistent Posters<HelpTip text="Accounts posting about this subject on many separate days over the last 90 days — sustained attention over time. Includes accounts that never cross the hostile threshold, which the Hostile Mention Watch does not show." /></div>
                        <div className="flex items-center gap-3">
                            <div className="font-mono text-xs text-muted">{posters.length} account{posters.length !== 1 ? 's' : ''} · last 90 days</div>
                            <div className="text-xs text-muted">{open ? '▾' : '▸'}</div>
                        </div>
                    </div>
                    {open && (<>
                    <div className="text-xs text-muted mb-4" style={{ lineHeight: 1.6 }}>
                        Accounts posting on <b>many separate days</b> — sustained attention over time, hostile or not.
                        {belowThreshold.length > 0 && <> {belowThreshold.length} stay <b style={{ color: 'var(--amber)' }}>below the hostile threshold</b>, so the Hostile Mention Watch won&rsquo;t show them — but a fixated account that&rsquo;s always there is itself a pattern.</>}
                    </div>
                    <div className="border border-veil rounded overflow-hidden">
                        {shown.map((p, i) => {
                            const below = (p.hostile_count || 0) === 0;
                            return (
                                <div key={p.source_account} className="px-4 py-3 grid grid-cols-12 gap-3 items-center text-sm"
                                     style={{ borderBottom: i < shown.length - 1 ? '1px solid var(--rule)' : 'none', cursor: onSelectAccount ? 'pointer' : 'default' }}
                                     onClick={() => onSelectAccount && onSelectAccount(p.source_account)}
                                     title={onSelectAccount ? 'Show this account’s posts in the Hostile Mention Watch' : ''}>
                                    <div className="col-span-4 font-mono">@{p.source_account}
                                        <div className="text-xs text-dim">{(p.sources || []).join(' · ')}</div></div>
                                    <div className="col-span-5 text-xs text-muted font-mono">
                                        posted on <b className="text-paper">{p.active_days}</b> separate days{p.active_weeks > 1 && <> · {p.active_weeks} weeks</>} · {p.mentions} mentions
                                        <div className="text-dim">{fmtDate(p.first_seen)} → {fmtDate(p.last_seen)} ({p.span_days}d)</div>
                                    </div>
                                    <div className="col-span-3 text-right">
                                        {below
                                            ? <span className="label-tag" style={{ color: 'var(--amber)', borderColor: 'var(--amber)' }}>BELOW THRESHOLD</span>
                                            : <span className="label-tag" style={{ color: 'var(--red)', borderColor: 'var(--red)' }}>{p.hostile_count} HOSTILE</span>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {posters.length > 8 && (
                        <div className="mt-3 text-center">
                            <button className="font-mono text-xs uppercase tracking-widest text-muted hover:text-[var(--gold)]"
                                    onClick={() => setShowAll(v => !v)}>{showAll ? 'Show fewer' : `Show all ${posters.length}`}</button>
                        </div>
                    )}
                    </>)}
                </div>
            );
        }

export { PersistentPostersPanel };
